"use client";
import React, { useRef, useState } from 'react';
import PlayButton from './PlayButton';
import styles from './styles.module.scss';

const VideoBanner = ({ headline, copy, video, youtubeLink, embeddedVideoLink }) => {
  const videoRef = useRef(null); // Reference to the video element
  const [isPlaying, setIsPlaying] = useState(false); // State to manage play/pause

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying); // Toggle play/pause state
    }
  };

  const renderHeadline = headline && (
    <h2 className={styles.videoBanner__headline}>{headline}</h2>
  );

  const renderCopy = copy && (
    <div className={styles.videoBanner__copy} dangerouslySetInnerHTML={{ __html: copy || " "}} />
  );

  const renderIframe = (src) => (
    <iframe
      src={src}
      title="Video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      width="100%"
      height="100%"
    />
  );

  const renderVideo = () => {
    const { mediaItemUrl, mediaDetails, mimeType } = video?.node || {};
    return (
      <div className={styles.videoBanner__media}>
        <PlayButton playPauseFunc={togglePlayPause} />
        <video ref={videoRef} width={mediaDetails?.width} height={mediaDetails?.height} muted autoPlay controls>
          <source src={mediaItemUrl} type={mimeType} />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  };

  const renderMedia = () => {
    if (embeddedVideoLink) {
      return <div className={styles.videoBanner__media}>{renderIframe(embeddedVideoLink)}</div>;
    }

    if (youtubeLink) {
      const videoId = new URL(youtubeLink).searchParams.get('v');
      return <div className={styles.videoBanner__media}>{renderIframe(`https://www.youtube.com/embed/${videoId}`)}</div>;
    }

    return renderVideo();
  };

  return (
    <section className={styles.videoBanner}>
      <div className="container">
        {renderHeadline}
        {renderCopy}
        {renderMedia()}
      </div>
    </section>
  );
};

export default VideoBanner;
